import React from 'react';
import { PageHeader } from './PageHeader';
import { Reveal } from '../ui/Reveal';
export interface LegalBlock {
  type: 'p' | 'list';
  text?: string;
  items?: string[];
}
export interface LegalSection {
  heading: string;
  blocks: LegalBlock[];
}
interface LegalLayoutProps {
  title: string;
  subtitle: string;
  updated: string;
  intro?: string;
  sections: LegalSection[];
}
export const LegalLayout = ({
  title,
  subtitle,
  updated,
  intro,
  sections
}: LegalLayoutProps) => {
  return <>
      <PageHeader eyebrow="Legal" title={title} subtitle={subtitle} data-id="element-1176" />

      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 pb-24 -mt-4" data-id="element-1177">
        <Reveal data-id="element-1178">
          <p className="text-xs font-semibold uppercase tracking-wider text-zano-pink mb-8" data-id="element-1179">
            Updated {updated}
          </p>

          {intro && <p className="text-gray-600 leading-relaxed mb-10" data-id="element-1180">{intro}</p>}

          <div className="space-y-10" data-id="element-1181">
            {sections.map((section, i) => <div key={i} data-id="element-1182">
                <h2 className="text-lg font-bold text-zano-charcoal mb-3" data-id="element-1183">
                  {i + 1}. {section.heading}
                </h2>
                <div className="space-y-3" data-id="element-1184">
                  {section.blocks.map((block, j) => block.type === 'list' ? <ul key={j} className="list-disc pl-5 space-y-2 text-gray-600 leading-relaxed" data-id="element-1185">
                        {block.items?.map((item, k) => <li key={k} data-id="element-1186">{item}</li>)}
                      </ul> : <p key={j} className="text-gray-600 leading-relaxed" data-id="element-1187">
                        {block.text}
                      </p>)}
                </div>
              </div>)}
          </div>
        </Reveal>
      </section>
    </>;
};